import TicketStatusTableValue from './TicketStatusTableValue';
import { TriageTicket } from 'src/services/triage/types';

const TicketStatusTableCell = ({ data }: { data: string }) => {
  return <TicketStatusTableValue status={data as TriageTicket['status']} />;
};

export default TicketStatusTableCell;
